import { logger } from '../logging'

// Special non-country codes used by IP geolocation services
const SPECIAL_CODES: Record<string, string> = {
  T1: 'N/A', // Tor Exit Node
  A1: 'N/A', // Anonymous Proxy
  A2: 'a Satellite Provider',
  O1: 'N/A', // Other/Unknown Country
  AP: 'Asia/Pacific Region',
  EU: 'Europe',
}

export function getDisplayCountry(country: string, locale = 'en'): string {
  // Handle special geolocation codes that aren't real countries
  if (country in SPECIAL_CODES) {
    return SPECIAL_CODES[country]!
  }

  // Ensure locale is valid and not empty
  const safeLocale = locale && locale.trim() ? locale.trim() : 'en'

  try {
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      const englishRegions = new Intl.DisplayNames([safeLocale], { type: 'region' })
      const displayName = englishRegions.of(country)
      if (displayName) {
        return displayName
      }
    }
  } catch (e) {
    if (e instanceof Error) {
      logger().warn(
        `Error getting display country for ${country} and locale: ${safeLocale}`,
        { country, locale: safeLocale },
        e,
      )
    }
  }
  // Fallback to country code if Intl.DisplayNames is not available
  return country
}
